import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import * as Yup from "yup";
import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import { FormGroup, Label, Button, UncontrolledPopover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody, Spinner, Card } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";
import { loginAxios } from '../../../config/axios.config';
import { toast, ToastContainer } from "react-toastify";
import { useParams, useHistory } from "react-router-dom";
import moment from "moment";
import {
    Icon,
    RSelect,
    Row,
    Col,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Block,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableRow,
    DataTableItem,
} from "../../../components/Component";

import Content from "../../../layout/content/Content";
import LoadingSpinner from '../../../components/loader/Loader';
import { getinvoicePayments, createNewInvoice, printInvoice, invoiceUpdateDetails } from '../../../redux/uploadInvoice/action';

const ViewInvoiceDetails = () => {

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const invoice_number = urlParams.get('invoice_number');

    const [viewDetails, setViewDetails] = useState({});

    const getinvoicePaymentsCall = useMutation(getinvoicePayments);
    const createNewInvoiceCall = useMutation(createNewInvoice);
    const printInvoiceCall = useMutation(printInvoice);






    useEffect(() => {
        if (invoice_number) {
            getinvoicePaymentsCall.mutate(invoice_number, {
                onSettled(data, error) {
                    if (data) {
                        console.log(data?.data);
                        setViewDetails(data?.data);
                    } else {
                        console.log(error);
                    }
                }
            });
        }
    }, [])


    const handleDownloadNote = (file_path) => {
        console.log(file_path);
        window.open(file_path, '_blank');
    }

    return (<>

        <Content>
            {(getinvoicePaymentsCall?.isLoading || printInvoiceCall?.isLoading) && <LoadingSpinner />}

            <BlockHead size="sm" className="mt-4">
                <BlockBetween>
                    <BlockHeadContent>
                        <h5 className="title">Invoice Details</h5>
                    </BlockHeadContent>
                </BlockBetween>
            </BlockHead>

            <Block>

            <Card className="card-stretch p-4">         
                    <h6 style={{fontWeight: 'normal'}}><span><b>Aza Invoice:</b> {viewDetails?.summary?.invoice_number}</span>  <span  style={{marginRight: '10px', marginLeft: '10px'}}>|</span>  <span><b>Designer Invoice:</b> {viewDetails?.summary?.designer_invoice_no}</span></h6>
                </Card>

                <Card className="card-stretch p-4">
                    {/* <h6>Invoices</h6> */}
                    <table className="invoice-item-table mb-4">
                        <thead>
                            <tr>
                                <th scope="col">Line No.</th>
                                {/* <th scope="col">{viewDetails?.summary?.type == 0 ? "Barcode" : "PO Number"}</th> */}
                                <th scope="col">PO Number</th>
                                <th scope="col">Barcode</th>                                
                                <th scope="col">Tracking Status</th>
                                <th scope="col">Eligible For Payment</th>
                                <th scope="col">Line Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {viewDetails?.invoice_details?.map((record, index) => (
                                <tr key={index}>
                                    <td>{record?.sr_no}</td>
                                    {/* <td>{record?.po_or_barcode}</td> */}                                    
                                    <td>{viewDetails?.summary?.type == 0 ? `M${record?.po_number}` : record?.po_number}</td>
                                    <td>{record?.barcode}</td>
                                    {/* <td>{viewDetails?.summary?.type == 0 ? record?.barcode : `P${record?.barcode}`}</td> */}
                                    <td>{record?.current_status}</td>
                                    <td>{record?.is_eligible_for_payment == 1 ? 'Yes' : 'No'}</td>
                                    <td>{record?.line_amount}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <br />

                    <Row className="gy-3">
                        <Col md={6}>
                            <h6>Deductions</h6>
                            <div className="card-inner-group">

                                <DataTable className="card-stretch">
                                    <DataTableBody compact>
                                        <DataTableHead>
                                            {/* <DataTableRow size="md">
                                                <span>Invoice Number</span>
                                            </DataTableRow> */}
                                            <DataTableRow size="md">
                                                <span>Document Number</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                                <span>Download</span>
                                            </DataTableRow>

                                            <DataTableRow size="md">
                                                <span>Reason</span>
                                            </DataTableRow>

                                            <DataTableRow size="sm">
                                                <span>Description</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                                <span>Amount</span>
                                            </DataTableRow>
                                            
                                            {/* <DataTableRow size="md">
                                                <span>Date Added</span>
                                            </DataTableRow> */}

                                        </DataTableHead>

                                        {viewDetails?.deductions?.length > 0
                                            ? viewDetails?.deductions?.map((item) => {
                                                return (
                                                    <DataTableItem key={item.id}>

                                                        {/* <DataTableRow size="md">
                                                            <span>{item.invoice_number}</span>
                                                        </DataTableRow> */}
                                                        <DataTableRow size="md">
                                                            <span>{item?.document_no}</span>
                                                        </DataTableRow>

                                                        <DataTableRow size="md">
                                                            {/* <button className="btn btn-primary btn-xs"> */}
                                                                <span style={{padding: '6px', cursor: 'pointer'}} onClick={() => handleDownloadNote(item?.file_url)}><Icon name="download"></Icon></span>
                                                                {/* </button> */}
                                                        </DataTableRow>

                                                        <DataTableRow size="md">
                                                            <span>{item.reason}</span>
                                                        </DataTableRow>

                                                        <DataTableRow size="sm">
                                                            <span>{item.description}</span>
                                                        </DataTableRow>
                                                        <DataTableRow size="md">
                                                            <span>{item?.amount}</span>
                                                        </DataTableRow>
                                                        
                                                        {/* <DataTableRow size="md">
                                                            <span>{<span>{moment(item.date_added).format("YYYY-MM-DD HH:mm")}</span>}</span>
                                                        </DataTableRow> */}

                                                    </DataTableItem>
                                                );
                                            })
                                            : null}

                                    </DataTableBody>
                                </DataTable>
                            </div>
                        </Col>


                        <Col md={6}>
                            <h6>Payments</h6>
                            <div className="card-inner-group">
                                <DataTable className="card-stretch">
                                    <DataTableBody compact>
                                        <DataTableHead>
                                            {/* <DataTableRow size="md">
                                                <span>Invoice Number</span>
                                            </DataTableRow> */}
                                            {/* <DataTableRow size="md">
                                                <span>Payment Batch ID</span>
                                            </DataTableRow> */}

                                            <DataTableRow size="md">
                                                <span>UTR No.</span>
                                            </DataTableRow>

                                            <DataTableRow size="md">
                                                <span>Payment Date</span>
                                            </DataTableRow>


                                            {/* <DataTableRow size="md">
                                                <span>Date Added</span>
                                            </DataTableRow> */}

                                            <DataTableRow size="sm">
                                                <span>Amount Received</span>
                                            </DataTableRow>
                                            {/* <DataTableRow size="md">
                                                <span>Amount Pending</span>
                                            </DataTableRow> */}
                                            




                                        </DataTableHead>

                                        {viewDetails?.payments?.length > 0
                                            ? viewDetails?.payments?.map((item) => {
                                                return (
                                                    <DataTableItem key={item.id}>

                                                        {/* <DataTableRow size="md">
                                                            <span>{item.invoice_number}</span>
                                                        </DataTableRow> */}
                                                        {/* <DataTableRow size="md">
                                                            <span>{item.batch_id}</span>
                                                        </DataTableRow> */}

                                                        <DataTableRow size="md">
                                                            <span>{item?.utr_number}</span>
                                                        </DataTableRow>

                                                        <DataTableRow size="md">
                                                            <span>{item.payment_date}</span>
                                                        </DataTableRow>


                                                        {/* <DataTableRow size="md">
                                                            <span>{<span>{moment(item.date_added).format("YYYY-MM-DD")}</span>}</span>
                                                        </DataTableRow> */}
                                                        
                                                        <DataTableRow size="sm">
                                                            <span>{item.amount_paid}</span>
                                                        </DataTableRow>
                                                        {/* <DataTableRow size="md">
                                                            <span>{item.amount_pending}</span>
                                                        </DataTableRow> */}
                                                        


                                                    </DataTableItem>
                                                );
                                            })
                                            : null}

                                    </DataTableBody>
                                </DataTable>
                            </div>
                        </Col>
                    </Row>


                    <Row className="mt-2">
                        <Col md="8"></Col>
                        <Col md="4">
                            <div className="mt-2">
                                <h6>Invoice Summary</h6>
                                <table className="table">
                                    {/* table-striped */}
                                    <thead>
                                        <tr>
                                            <th className="w-150px">Invoice Total</th>
                                            <th className="text-right w-60">{viewDetails?.summary?.invoice_amount}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Eligible For Payment</td>
                                            <td align="right">{viewDetails?.summary?.amount_eligible_for_payment}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Deductions</td>
                                            <td align="right">{viewDetails?.summary?.deductions}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Amount Receivable</td>
                                            <td align="right">{viewDetails?.summary?.amount_receivable}</td>
                                        </tr>
                                        <tr>
                                            <td>Amount Received</td>
                                            <td align="right">{viewDetails?.summary?.received_amount}</td>
                                        </tr>
                                        <tr>
                                            <td>Pending Amount</td>
                                            <td align="right">{viewDetails?.summary?.pending_amount}</td>
                                        </tr>
                                    </tbody>
                                </table>




                            </div>
                        </Col>
                    </Row>

                </Card>
            </Block>
        </Content>
        <ToastContainer />

    </>)
};

export default ViewInvoiceDetails;